export default {
  isAuthenticated: state => !!state.user.token,
  isDemoMode: state => state.appMode === "demo",
  authStatus: state => state.status,
  isPlanUnpaid: state =>
    state.planRestrictions ? state.planRestrictions.is_unpaid : false,
  planName: state =>
    state.planRestrictions ? state.planRestrictions.name : null,
  planExpiresAt: state =>
    state.planRestrictions ? state.planRestrictions.expires_at : null,
  subscriptionExpiresIn: state => {
    if (!state.planRestrictions) {
      return "";
    }
    return Math.ceil(
      (new Date(state.planRestrictions.expires_at) - new Date()) /
        (1000 * 60 * 60 * 24)
    );
  },
  isFreeTrial: state =>
    state.planRestrictions ? state.planRestrictions.is_free_trial : false
};
